"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HTTPError", {
  enumerable: true,
  get: function get() {
    return _fn2.HTTPError;
  }
});
exports.MULTIPART = exports.DELETE = exports.PATCH = exports.POST = exports.GET = exports.set = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _rfc = _interopRequireDefault(require("rfc-3986"));

var _m = require("@mutant-ws/m");

var _fn = require("./fn.set-props");

var _fn2 = require("./fn.http-error");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Config
 */
var props = {
  baseURL: "",
  headers: {},
  queryStringifyFn: null
};
/**
 * `window.fetch` with qs support, default headers and rejects on status
 * outside 200
 *
 * @param  {String} path        API endpoint
 * @param  {String} opt.method  HTTP Method
 * @param  {Object} opt.headers HTTP Headers
 * @param  {Object} opt.body    HTTP Body
 * @param  {Object} opt.query   Query params
 *
 * @return {Promise}            Resolves with response object if code is 20*.
 *                              Reject all other response codes.
 */

var request = function request(path) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      method = _ref.method,
      _ref$body = _ref.body,
      body = _ref$body === void 0 ? {} : _ref$body,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers,
      _ref$query = _ref.query,
      query = _ref$query === void 0 ? {} : _ref$query;

  if (!(0, _m.isEmpty)(query) && (0, _m.isEmpty)(props.queryStringifyFn)) {
    throw new TypeError("@mutant-ws/fetch-browser: ".concat(method, ":").concat(path, " - Cannot send query params without providing \"queryStringifyFn\""));
  }

  var isPathURI = new RegExp(_rfc["default"].uri).test(path);

  if ((0, _m.isEmpty)(props.baseURL) && !isPathURI) {
    throw new TypeError("@mutant-ws/fetch-browser: ".concat(method, ":").concat(path, " - Cannot make request with non-absolute path and no \"baseURL\""));
  } // - Remove all undefined values
  // - toLower all keys


  var HEADERS = (0, _m.reduce)(function (acc, _ref2) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return (0, _m.is)(value) ? _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, (0, _m.toLower)(key), value)) : acc;
  }, {})(Object.entries(_objectSpread(_objectSpread({
    accept: "application/json",
    "content-type": "application/json"
  }, props.headers), headers)));
  var isReqJSON = (0, _m.pipe)((0, _m.get)("content-type", ""), (0, _m.startsWith)("application/json"))(HEADERS);
  var URI = (0, _m.pipe)((0, _m.when)(_m.isEmpty, (0, _m.same)(path), function (source) {
    return "".concat(path, "?").concat(props.queryStringifyFn(source));
  }), (0, _m.trim)("/"), function (source) {
    return isPathURI ? source : "".concat(props.baseURL, "/").concat(source);
  })(query);
  return window.fetch(URI, _objectSpread({
    method: method,
    headers: HEADERS
  }, method === "GET" ? {} : {
    body: isReqJSON ? JSON.stringify(body) : body
  })).then(function (response) {
    var isResJSON = (0, _m.startsWith)("application/json")(response.headers.get("Content-Type"));
    return Promise.all([response, isResJSON ? response.json() : response.text()]);
  }).then(function (_ref4) {
    var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
        response = _ref5[0],
        data = _ref5[1];

    /*
     * The Promise returned from fetch() won't reject on HTTP error status
     * even if the response is an HTTP 404 or 500. Instead, it will resolve
     * normally, and it will only reject on network failure or if anything
     * prevented the request from completing.
     */
    if (response.ok) {
      return data;
    }

    throw new _fn2.HTTPError(response.statusText, {
      status: response.status,
      body: data,
      path: URI
    });
  });
};

var set = (0, _fn.setProps)(props);
exports.set = set;

var GET = function GET(url) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      query = _ref6.query,
      headers = _ref6.headers;

  return request(url, {
    method: "GET",
    query: query,
    headers: headers
  });
};

exports.GET = GET;

var POST = function POST(url) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      body = _ref7.body,
      query = _ref7.query,
      headers = _ref7.headers;

  return request(url, {
    method: "POST",
    body: body,
    query: query,
    headers: headers
  });
};

exports.POST = POST;

var PATCH = function PATCH(url) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      body = _ref8.body,
      query = _ref8.query,
      headers = _ref8.headers;

  return request(url, {
    method: "PATCH",
    body: body,
    query: query,
    headers: headers
  });
};

exports.PATCH = PATCH;

var DELETE = function DELETE(url) {
  var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      body = _ref9.body,
      query = _ref9.query,
      headers = _ref9.headers;

  return request(url, {
    method: "DELETE",
    body: body,
    query: query,
    headers: headers
  });
};

exports.DELETE = DELETE;

var MULTIPART = function MULTIPART(url) {
  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref10$body = _ref10.body,
      body = _ref10$body === void 0 ? {} : _ref10$body,
      headers = _ref10.headers;

  var form = new FormData();
  return request(url, {
    method: "POST",
    body: (0, _m.reduce)(function (acc, _ref11) {
      var _ref12 = (0, _slicedToArray2["default"])(_ref11, 2),
          key = _ref12[0],
          value = _ref12[1];

      acc.append(key, value);
      return acc;
    }, form)(Object.entries(body)),
    headers: _objectSpread(_objectSpread({}, headers), {}, {
      // remove content-type header or browser boundery wont get set
      "content-type": undefined
    })
  });
};

exports.MULTIPART = MULTIPART;